<ng-container *vsLet="staffView$ | async as staffView">
  <ws-provision-warranty-complete
    *ngIf="warranty$ | async as warranty; else noWarranty"
    [warranty]="warranty"
    [staffView]="staffView ?? false"
  ></ws-provision-warranty-complete>

  <ng-template #noWarranty>
    <ng-container *vsLet="session$ | async as session">
      <div
        *vsLet="isLargeScreen$ | async as isLargeScreen"
        class="flex gap-4 w-full justify-center {{ isLargeScreen === false ? 'flex-col' : '' }}"
      >
        <ng-container *vsLet="preview$ | async as preview">
          <ng-container *vsLet="preview?.purchase as purchase">
            <ng-container *ngIf="(baseCoverages$ | async) && (selectedAddons$ | async)">
              <ng-container *ngIf="!isLoading && (bfsEnabled$ | async) !== null; else loading">
                <ng-container *ngIf="(purchase?.payments?.[0]?.amount ?? 0) > 0; else provisionWarranty">
                  <div *vsLet="selectedTerm$ | async as selectedTerm" class="flex flex-col gap-12 w-full items-center">
                    <div class="flex flex-col gap-4 justify-center items-center text-center">
                      <vs-featured-icon name="bank" theme="primary" size="28"></vs-featured-icon>

                      <div class="text-3xl font-semibold">{{ checkoutConfig.REVIEW_TITLE }}</div>
                      <div class="text-gray-600">
                        {{ checkoutConfig.REVIEW_SUBTITLE }}
                      </div>
                    </div>

                    <ng-container *vsLet="canFinanceWithBfs$ | async as canFinanceWithBfs">
                      <ng-container *vsLet="canFinanceWithLemur$ | async as canFinanceWithLemur">
                        <vs-card
                          *vsLet="paymentSchedules$ | async as paymentSchedules"
                          class="w-full"
                          [class.max-w-3xl]="!bfsActivationUrl"
                          [class.max-w-6xl]="!!bfsActivationUrl"
                        >
                          <vs-card-header [config]="{ title: 'Payment' }">
                            <div
                              class="flex items-center gap-2"
                              *ngIf="
                                staffView &&
                                !payLater &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                !multiPhaseEnabled
                              "
                              slot="end"
                            >
                              <label class="whitespace-nowrap" for="staff-pays">Pay for Customer</label>
                              <input
                                vsInput
                                appearance="toggle"
                                type="checkbox"
                                id="staff-pays"
                                [checked]="payingForCustomer$ | async"
                                (change)="payingForCustomer$.next($any($event).target.checked)"
                              />
                            </div>
                            <div
                              *ngIf="
                                staffView &&
                                !payLater &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                !multiPhaseEnabled
                              "
                              class="text-warn mt-2 max-w-lg"
                            >
                              <p>
                                <small>
                                  {{
                                    (payingForCustomer$ | async)
                                      ? "Your payment method will be used to buy this policy for the customer. To use the customer's payment methods for this purchase, uncheck the option above."
                                      : 'Payment methods associated with the customer will be used to buy this policy, you can add a new one on behalf of the customer. To use your own payment method for this purchase, toggle the option above.'
                                  }}</small
                                >
                              </p>
                            </div>
                          </vs-card-header>
                          <vs-card-content class="flex flex-col gap-4">
                            <div *ngIf="canFinanceWithLemur" class="flex w-full flex-col gap-3 rounded border p-4">
                              <div class="text-sm font-semibold text-gray-700">Choose how to pay</div>
                              <div class="flex flex-col gap-2 sm:flex-row" role="group" aria-label="Payment option">
                                <button
                                  type="button"
                                  vs-button
                                  appearance="outline"
                                  class="!w-full"
                                  [attr.aria-pressed]="lemurPaymentMode === 'pay-now'"
                                  (click)="selectLemurPaymentMode('pay-now')"
                                >
                                  Pay now
                                </button>
                                <button
                                  type="button"
                                  vs-button
                                  appearance="outline"
                                  class="!w-full"
                                  [attr.aria-pressed]="lemurPaymentMode === 'finance'"
                                  (click)="selectLemurPaymentMode('finance')"
                                >
                                  {{ checkoutConfig.LEMUR_PAYMENT_TITLE }}
                                </button>
                              </div>

                              <div *ngIf="lemurPaymentMode === 'finance'" class="flex flex-col gap-2 border-t pt-3">
                                <p class="text-sm text-gray-600">{{ checkoutConfig.LEMUR_PAYMENT_DESCRIPTION }}</p>
                                <ws-lemur-financing-form
                                  [sessionId]="session?.id ?? ''"
                                  [hash]="session?.hash"
                                  [staffView]="staffView ?? false"
                                  (returnToPayNow)="selectLemurPaymentMode('pay-now')"
                                  (financingCompleted)="completeLemurCheckout($event)"
                                ></ws-lemur-financing-form>
                              </div>
                            </div>

                            <!-- BFS / Budco payment timing -->
                            <div *ngIf="canFinanceWithBfs" class="flex w-full flex-col gap-2 rounded border p-4">
                              <div class="text-sm font-semibold text-gray-700">Payment timing</div>

                              <p *ngIf="(bfsConfigured$ | async) !== true" role="alert" class="text-warn">
                                Budco payments are currently unavailable. Please contact support.
                              </p>
                              <!-- Option buttons — hidden once a pending BFS warranty has been created -->
                              <div
                                *ngIf="!hasBfsPendingWarranty && (bfsConfigured$ | async) === true"
                                class="flex gap-2"
                              >
                                <button
                                  type="button"
                                  vs-button
                                  size="lg"
                                  theme="default"
                                  appearance="outline"
                                  class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                  [rounded]="false"
                                  [disabled]="isRequestingQuote"
                                  (click)="onSelectBudcoPayment(session?.id, staffView ?? false)"
                                >
                                  <div class="flex gap-2 w-full items-center">
                                    <vs-icon size="24" name="bank" class="!text-primary"></vs-icon>
                                    <p class="w-full !font-semibold !text-sm">
                                      {{ checkoutConfig.BUDCO_PAYMENT_TITLE }}
                                    </p>
                                  </div>

                                  <vs-icon
                                    size="16"
                                    theme="primary"
                                    class="text-primary-500 self-center rounded-full border-themed-200"
                                    [type]="bfsSelectedOption === 'budco' ? 'solid' : 'line'"
                                    [name]="bfsSelectedOption === 'budco' ? 'check-circle' : 'circle'"
                                  ></vs-icon>
                                </button>

                                <button
                                  *ngIf="selectedTerm?.paymentOptional"
                                  vs-button
                                  size="lg"
                                  theme="default"
                                  appearance="outline"
                                  class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                  [rounded]="false"
                                  (click)="setPayLater(true)"
                                >
                                  <div class="flex gap-2 w-full items-center">
                                    <vs-icon size="24" name="file-check-02" class="!text-primary"></vs-icon>
                                    <p class="w-full !font-semibold !text-sm">{{ checkoutConfig.PAY_LATER_TITLE }}</p>
                                  </div>

                                  <vs-icon
                                    size="16"
                                    theme="primary"
                                    class="text-primary-500 self-center rounded-full border-themed-200"
                                    [type]="payLater ? 'solid' : 'line'"
                                    [name]="payLater ? 'check-circle' : 'circle'"
                                  ></vs-icon>
                                </button>
                              </div>

                              <p
                                *ngIf="payLater"
                                class="flex flex-col gap-3 text-sm text-gray-600 rounded bg-gray-50 border p-3"
                              >
                                <span>{{ checkoutConfig.PAY_LATER_DESCRIPTION }}</span>
                                <button
                                  type="button"
                                  vs-button
                                  theme="default"
                                  appearance="outline"
                                  size="sm"
                                  class="self-start"
                                  (click)="setPayLater(false)"
                                >
                                  {{ checkoutConfig.CHANGE_PAYMENT_OPTION_TITLE }}
                                </button>
                              </p>

                              <p
                                *ngIf="bfsSelectedOption === 'budco' && !bfsActivationUrl && !hasBfsPendingWarranty"
                                class="text-sm text-gray-600"
                              >
                                {{ checkoutConfig.BUDCO_PAYMENT_DESCRIPTION }}
                              </p>

                              <!-- Resume banner — shown when BFS pending warranty exists but iframe was closed -->
                              <div
                                *ngIf="hasBfsPendingWarranty && !bfsActivationUrl && !isRequestingQuote"
                                class="flex flex-col gap-3 border-t pt-3"
                              >
                                <div
                                  class="flex items-start gap-2 rounded bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800"
                                >
                                  <vs-icon size="16" name="alert-triangle" class="mt-0.5 shrink-0"></vs-icon>
                                  <span>
                                    A Budco financing request is already in progress for this session. Please complete
                                    the financing form or start a new checkout — switching to a different payment method
                                    is not available.
                                  </span>
                                </div>
                                <ng-container [ngSwitch]="bfsFundingState">
                                  <div *ngSwitchCase="'pending'" role="status" class="text-xs text-gray-600">
                                    Budco hasn't confirmed payment for this contract yet. If the financing form was
                                    completed, the warranty is activated as soon as Budco confirms it.
                                  </div>
                                  <div *ngSwitchCase="'unavailable'" role="alert" class="text-xs text-yellow-800">
                                    We couldn't confirm payment with Budco right now. The warranty stays pending — check
                                    again in a few minutes.
                                  </div>
                                  <div *ngSwitchCase="'failed'" role="alert" class="text-xs text-warn">
                                    Budco financing was not completed. The warranty remains pending.
                                  </div>
                                  <div
                                    *ngSwitchDefault
                                    role="status"
                                    class="flex items-center gap-2 text-xs text-gray-600"
                                  >
                                    <vs-icon size="14" name="loading-01" class="animate-spin"></vs-icon>
                                    Waiting for Budco to confirm payment. This page will update automatically once the
                                    warranty is activated.
                                  </div>
                                </ng-container>
                                <div class="flex flex-wrap items-center gap-2">
                                  <button type="button" vs-button theme="primary" (click)="reopenBfsIframe()">
                                    Resume Budco financing
                                  </button>
                                  <button
                                    type="button"
                                    vs-button
                                    appearance="outline"
                                    [disabled]="isCheckingBfsFunding"
                                    (click)="checkBfsFunding()"
                                  >
                                    {{ isCheckingBfsFunding ? 'Checking…' : 'Check payment status' }}
                                  </button>
                                </div>
                              </div>

                              <!-- Pay with BFS: Pay now and Finance sub-options -->
                              <div
                                *ngIf="bfsSelectedOption === 'budco' && !bfsActivationUrl && !hasBfsPendingWarranty"
                                class="flex w-full flex-col gap-3 border-t pt-3"
                              >
                                <div class="text-sm font-semibold text-gray-700">
                                  Pay with Budco Financial Services (BFS)
                                </div>

                                <div class="flex gap-2">
                                  <button
                                    type="button"
                                    vs-button
                                    size="lg"
                                    theme="default"
                                    appearance="outline"
                                    class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                    [rounded]="false"
                                    [disabled]="isRequestingQuote"
                                    (click)="selectBfsPayNow(session?.id, staffView ?? false)"
                                  >
                                    <div class="flex gap-2 w-full items-center">
                                      <vs-icon size="24" name="bank-note-01" class="!text-primary"></vs-icon>
                                      <p class="w-full !font-semibold !text-sm">Pay now</p>
                                    </div>

                                    <vs-icon
                                      size="16"
                                      theme="primary"
                                      class="text-primary-500 self-center rounded-full border-themed-200"
                                      [type]="bfsPaymentMode === 'pay-now' ? 'solid' : 'line'"
                                      [name]="bfsPaymentMode === 'pay-now' ? 'check-circle' : 'circle'"
                                    ></vs-icon>
                                  </button>

                                  <button
                                    type="button"
                                    vs-button
                                    size="lg"
                                    theme="default"
                                    appearance="outline"
                                    class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                    [rounded]="false"
                                    [disabled]="isRequestingQuote"
                                    (click)="selectBfsFinance(session?.id, staffView ?? false)"
                                  >
                                    <div class="flex gap-2 w-full items-center">
                                      <vs-icon size="24" name="clock-refresh" class="!text-primary"></vs-icon>
                                      <p class="w-full !font-semibold !text-sm">Finance</p>
                                    </div>

                                    <vs-icon
                                      size="16"
                                      theme="primary"
                                      class="text-primary-500 self-center rounded-full border-themed-200"
                                      [type]="bfsPaymentMode === 'finance' ? 'solid' : 'line'"
                                      [name]="bfsPaymentMode === 'finance' ? 'check-circle' : 'circle'"
                                    ></vs-icon>
                                  </button>
                                </div>

                                <div *ngIf="bfsPaymentMode === 'finance'" class="grid w-full gap-4 sm:grid-cols-2">
                                  <div class="flex w-full flex-col gap-1">
                                    <label class="text-sm font-medium text-gray-700">Down Payment Amount</label>
                                    <input
                                      class="bfs-finance-input w-full h-14 rounded-md border border-gray-300 px-3 text-base shadow-sm transition focus:border-primary-300 focus:outline-none focus:ring-4 focus:ring-primary-100"
                                      type="number"
                                      step="0.01"
                                      [formControl]="bfsDownPaymentAmount"
                                    />
                                    <p class="text-xs text-gray-500">
                                      Minimum
                                      {{ getMinDownPaymentAmount(getRetailPrice(preview)) | currency }}
                                      ({{ getMinDownPaymentPercentDisplay() }}% of purchase price)
                                    </p>
                                  </div>

                                  <div class="flex w-full flex-col gap-1">
                                    <label class="text-sm font-medium text-gray-700">Payment Term (months)</label>
                                    <input
                                      class="bfs-finance-input w-full h-14 rounded-md border border-gray-300 px-3 text-base shadow-sm transition focus:border-primary-300 focus:outline-none focus:ring-4 focus:ring-primary-100"
                                      type="number"
                                      [min]="checkoutConfig.BUDCO_MIN_TERM_MONTHS"
                                      [max]="checkoutConfig.BUDCO_MAX_TERM_MONTHS"
                                      step="1"
                                      [formControl]="bfsTermLength"
                                    />
                                    <p class="text-xs text-gray-500">
                                      Between {{ checkoutConfig.BUDCO_MIN_TERM_MONTHS }} and
                                      {{ checkoutConfig.BUDCO_MAX_TERM_MONTHS }} months
                                    </p>
                                  </div>

                                  <button
                                    type="button"
                                    vs-button
                                    theme="primary"
                                    class="sm:col-span-2 self-start"
                                    [disabled]="
                                      isRequestingQuote || bfsDownPaymentAmount.invalid || bfsTermLength.invalid
                                    "
                                    (click)="submitBfsFinanceQuote(session?.id, staffView ?? false)"
                                  >
                                    Continue to payment
                                  </button>
                                </div>
                              </div>

                              <div *ngIf="isRequestingQuote" class="flex items-center gap-2 text-gray-500">
                                <vs-icon size="16" name="loading-01" class="animate-spin"></vs-icon>
                                Preparing quote...
                              </div>

                              <div *ngIf="bfsActivationUrl" class="mt-2 overflow-hidden rounded border">
                                <div class="flex justify-end border-b p-2">
                                  <button
                                    type="button"
                                    vs-button
                                    appearance="outline"
                                    size="sm"
                                    (click)="closeFinanceWithBfs()"
                                  >
                                    Hide financing form
                                  </button>
                                </div>
                                <iframe
                                  #bfsIframe
                                  [src]="bfsActivationUrl"
                                  title="Budco Financial Services (BFS) Financing"
                                  class="h-[760px] w-full border-0"
                                  (load)="onBfsIframeLoad($event.target)"
                                ></iframe>
                              </div>
                            </div>

                            <!-- Authorize.Net: pay now vs pay later when the term allows deferred payment -->
                            <div
                              *ngIf="
                                selectedTerm?.paymentOptional &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now')
                              "
                              class="flex flex-col gap-2 p-3 border rounded"
                            >
                              <div class="text-sm font-semibold text-gray-700">Payment timing</div>

                              <div class="flex gap-2">
                                <button
                                  vs-button
                                  size="lg"
                                  theme="default"
                                  appearance="outline"
                                  class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                  [rounded]="false"
                                  (click)="setPayLater(false)"
                                >
                                  <div class="flex gap-2 w-full items-center">
                                    <vs-icon size="24" name="bank-note-01" class="!text-primary"></vs-icon>
                                    <p class="w-full !font-semibold !text-sm">Pay now</p>
                                  </div>

                                  <vs-icon
                                    size="16"
                                    theme="primary"
                                    class="text-primary-500 self-center rounded-full border-themed-200"
                                    [type]="!payLater ? 'solid' : 'line'"
                                    [name]="!payLater ? 'check-circle' : 'circle'"
                                  ></vs-icon>
                                </button>

                                <button
                                  vs-button
                                  size="lg"
                                  theme="default"
                                  appearance="outline"
                                  class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                  [rounded]="false"
                                  (click)="setPayLater(true)"
                                >
                                  <div class="flex gap-2 w-full items-center">
                                    <vs-icon size="24" name="clock-refresh" class="!text-primary"></vs-icon>
                                    <p class="w-full !font-semibold !text-sm">Pay later</p>
                                  </div>

                                  <vs-icon
                                    size="16"
                                    theme="primary"
                                    class="text-primary-500 self-center rounded-full border-themed-200"
                                    [type]="payLater ? 'solid' : 'line'"
                                    [name]="payLater ? 'check-circle' : 'circle'"
                                  ></vs-icon>
                                </button>
                              </div>

                              <small *ngIf="payLater" class="text-gray-500">
                                No credit card required. Warranty will be provisioned now; payment handled outside
                                WarrantySphere.
                              </small>
                            </div>

                            <div
                              *ngIf="
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                !payLater &&
                                paymentSchedules &&
                                paymentSchedules.oneTime &&
                                paymentSchedules.installments.length
                              "
                              class="flex justify-center gap-2"
                            >
                              <!-- Pay now -->
                              <button
                                (click)="selectPaymentSchedule(paymentSchedules.oneTime)"
                                vs-button
                                size="lg"
                                theme="default"
                                appearance="outline"
                                class="!justify-start !items-start !w-full !text-start !font-normal !p-2"
                                [rounded]="false"
                              >
                                <div class="flex gap-2 w-full -pt-[100px] items-center !self-center">
                                  <vs-icon size="24" name="bank-note-01" class="!text-primary"></vs-icon>
                                  <p class="w-full !font-semibold !text-sm">Pay now</p>
                                </div>

                                <vs-icon
                                  size="16"
                                  theme="primary"
                                  class="text-primary-500 self-start hover:border hover:-mr-[1px] rounded-full border-themed-200"
                                  [type]="(selectedPaymentSchedule?.installments || 1) === 1 ? 'solid' : 'line'"
                                  [name]="
                                    (selectedPaymentSchedule?.installments || 1) === 1 ? 'check-circle' : 'circle'
                                  "
                                ></vs-icon>
                              </button>

                              <!-- Pay in installments -->
                              <ng-container *ngFor="let paymentSchedule of paymentSchedules!.installments">
                                <button
                                  vs-button
                                  size="lg"
                                  theme="default"
                                  appearance="outline"
                                  class="!justify-start !items-start !w-full !text-start !font-normal !p-2"
                                  [rounded]="false"
                                  (click)="selectPaymentSchedule(paymentSchedule)"
                                >
                                  <div class="flex gap-2 w-full -pt-[100px] items-center !self-center">
                                    <vs-icon size="24" name="clock-refresh" class="!text-primary"></vs-icon>

                                    <p class="w-full !font-semibold !text-sm">Pay {{ paymentSchedule.title }}</p>
                                  </div>

                                  <vs-icon
                                    size="16"
                                    theme="primary"
                                    class="text-primary-500 self-start hover:border hover:-mr-[1px] rounded-full border-themed-200"
                                    [type]="
                                      selectedPaymentSchedule?.installments === paymentSchedule.installments
                                        ? 'solid'
                                        : 'line'
                                    "
                                    [name]="
                                      selectedPaymentSchedule?.installments === paymentSchedule.installments
                                        ? 'check-circle'
                                        : 'circle'
                                    "
                                  ></vs-icon>
                                </button>
                              </ng-container>
                            </div>

                            <div
                              *ngIf="
                                preview?.paymentCollectionUnavailable &&
                                !payLater &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now')
                              "
                              class="rounded border border-warn-300 p-4 text-sm text-gray-700"
                              role="alert"
                            >
                              <p class="font-semibold">No payment configuration has been enabled</p>
                              <p>
                                Select Pay Later to continue without collecting payment, or contact an administrator to
                                configure a payment gateway.
                              </p>
                            </div>

                            <!-- Multi-Phase Payment (staff only): split the installments across two phases -->
                            <div
                              *ngIf="
                                staffView &&
                                !payLater &&
                                !preview?.paymentCollectionUnavailable &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                totalInstallments > 1
                              "
                              class="flex flex-col gap-2 p-3 border rounded"
                            >
                              <div class="flex items-center justify-between gap-2">
                                <div class="text-sm font-semibold text-gray-700">
                                  {{ checkoutConfig.MULTI_PHASE_TITLE }}
                                </div>
                                <input
                                  vsInput
                                  appearance="toggle"
                                  type="checkbox"
                                  id="multi-phase"
                                  [checked]="multiPhaseEnabled"
                                  (change)="setMultiPhaseEnabled($any($event).target.checked)"
                                />
                              </div>
                              <p class="text-sm text-gray-600">{{ checkoutConfig.MULTI_PHASE_DESCRIPTION }}</p>

                              <ng-container *ngIf="multiPhaseEnabled">
                                <!-- Phase 1 -->
                                <div class="flex flex-col gap-3 border-t pt-3">
                                  <div class="flex items-center justify-between gap-2">
                                    <div class="text-sm font-semibold text-gray-700">
                                      {{ checkoutConfig.MULTI_PHASE_PHASE_ONE_TITLE }}
                                    </div>
                                    <div class="flex items-center gap-2">
                                      <label class="whitespace-nowrap text-sm" for="phase-one-seller-pays">
                                        {{ checkoutConfig.MULTI_PHASE_SELLER_PAYS_LABEL }}
                                      </label>
                                      <input
                                        vsInput
                                        appearance="toggle"
                                        type="checkbox"
                                        id="phase-one-seller-pays"
                                        [checked]="phaseOneSellerPays$ | async"
                                        (change)="setPhaseOneSellerPays($any($event).target.checked)"
                                      />
                                    </div>
                                  </div>

                                  <div class="flex w-full flex-col gap-1">
                                    <label class="text-sm font-medium text-gray-700">
                                      {{ checkoutConfig.MULTI_PHASE_INSTALLMENTS_LABEL(totalInstallments) }}
                                    </label>
                                    <input
                                      class="bfs-finance-input w-full h-14 rounded-md border border-gray-300 px-3 text-base shadow-sm transition focus:border-primary-300 focus:outline-none focus:ring-4 focus:ring-primary-100"
                                      type="number"
                                      min="1"
                                      [max]="totalInstallments - 1"
                                      step="1"
                                      [formControl]="phaseOneInstallments"
                                    />
                                    <p *ngIf="!phaseOneCountError" class="text-xs text-gray-500">
                                      {{ checkoutConfig.MULTI_PHASE_INSTALLMENTS_HINT(totalInstallments - 1) }}
                                    </p>
                                    <p *ngIf="phaseOneCountError" class="text-xs text-danger">
                                      {{ checkoutConfig.MULTI_PHASE_INSTALLMENTS_ERROR(totalInstallments - 1) }}
                                    </p>
                                  </div>

                                  <div class="flex gap-2">
                                    <button
                                      type="button"
                                      vs-button
                                      size="lg"
                                      theme="default"
                                      appearance="outline"
                                      class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                      [rounded]="false"
                                      (click)="setPhaseOneBillTo(false)"
                                    >
                                      <div class="flex gap-2 w-full items-center">
                                        <vs-icon size="24" name="credit-card-02" class="!text-primary"></vs-icon>
                                        <p class="w-full !font-semibold !text-sm">
                                          {{ checkoutConfig.MULTI_PHASE_METHOD_OPTION_TITLE }}
                                        </p>
                                      </div>

                                      <vs-icon
                                        size="16"
                                        theme="primary"
                                        class="text-primary-500 self-center rounded-full border-themed-200"
                                        [type]="!phaseOneBillTo ? 'solid' : 'line'"
                                        [name]="!phaseOneBillTo ? 'check-circle' : 'circle'"
                                      ></vs-icon>
                                    </button>

                                    <button
                                      type="button"
                                      vs-button
                                      size="lg"
                                      theme="default"
                                      appearance="outline"
                                      class="!justify-start !items-center !w-full !text-start !font-normal !p-2"
                                      [rounded]="false"
                                      (click)="setPhaseOneBillTo(true)"
                                    >
                                      <div class="flex gap-2 w-full items-center">
                                        <vs-icon size="24" name="file-check-02" class="!text-primary"></vs-icon>
                                        <p class="w-full !font-semibold !text-sm">
                                          {{ checkoutConfig.MULTI_PHASE_BILL_TO_TITLE }}
                                        </p>
                                      </div>

                                      <vs-icon
                                        size="16"
                                        theme="primary"
                                        class="text-primary-500 self-center rounded-full border-themed-200"
                                        [type]="phaseOneBillTo ? 'solid' : 'line'"
                                        [name]="phaseOneBillTo ? 'check-circle' : 'circle'"
                                      ></vs-icon>
                                    </button>
                                  </div>

                                  <p *ngIf="phaseOneBillTo" class="text-sm text-gray-600 rounded bg-gray-50 border p-3">
                                    {{ checkoutConfig.MULTI_PHASE_BILL_TO_DESCRIPTION }}
                                  </p>

                                  <label *ngIf="phaseOneBillTo && (phaseOneSellerPays$ | async)" class="block text-sm">
                                    Seller payment due date (optional)
                                    <input
                                      type="date"
                                      [formControl]="phaseOneDueDate"
                                      class="block w-full border rounded p-2 mt-1"
                                    />
                                    <span class="text-xs text-gray-500"
                                      >Leave blank until a payment date is agreed. The warranty remains frozen until all
                                      seller receipts are confirmed.</span
                                    >
                                  </label>

                                  <vs-accepted-payment-methods *ngIf="!phaseOneBillTo"></vs-accepted-payment-methods>

                                  <vs-select-or-create-payment-method
                                    *ngIf="!phaseOneBillTo"
                                    #phaseOneInput
                                    [gatewayInstanceId]="purchase?.payments?.[0]?.gatewayInstanceId ?? null"
                                    [address]="session?.shippingAddress || null"
                                    [userId]="(phaseOneUserId$ | async) ?? null"
                                    [userDetails]="{
                                      name: session?.customer?.name ?? '',
                                      email: session?.customer?.email ?? '',
                                      phone: session?.customer?.phone ?? '',
                                    }"
                                    [formControl]="phaseOneMethod"
                                    [staffView]="true"
                                  ></vs-select-or-create-payment-method>

                                  <p *ngIf="phaseOneMethodError" class="text-xs text-danger">
                                    {{ checkoutConfig.MULTI_PHASE_METHOD_REQUIRED_ERROR }}
                                  </p>
                                </div>

                                <!-- Phase 2 -->
                                <div class="flex flex-col gap-3 border-t pt-3">
                                  <div class="flex items-center justify-between gap-2">
                                    <div class="text-sm font-semibold text-gray-700">
                                      {{ checkoutConfig.MULTI_PHASE_PHASE_TWO_TITLE }}
                                    </div>
                                    <div class="flex items-center gap-2">
                                      <label class="whitespace-nowrap text-sm" for="phase-two-seller-pays">
                                        {{ checkoutConfig.MULTI_PHASE_SELLER_PAYS_LABEL }}
                                      </label>
                                      <input
                                        vsInput
                                        appearance="toggle"
                                        type="checkbox"
                                        id="phase-two-seller-pays"
                                        [checked]="phaseTwoSellerPays$ | async"
                                        (change)="setPhaseTwoSellerPays($any($event).target.checked)"
                                      />
                                    </div>
                                  </div>

                                  <p class="text-sm text-gray-600">
                                    {{
                                      phaseOneInstallments.value
                                        ? checkoutConfig.MULTI_PHASE_PHASE_TWO_COUNT(
                                            phaseTwoInstallmentCount(totalInstallments),
                                            totalInstallments
                                          )
                                        : checkoutConfig.MULTI_PHASE_PHASE_TWO_DESCRIPTION
                                    }}
                                  </p>

                                  <vs-accepted-payment-methods></vs-accepted-payment-methods>

                                  <vs-select-or-create-payment-method
                                    #phaseTwoInput
                                    [gatewayInstanceId]="purchase?.payments?.[0]?.gatewayInstanceId ?? null"
                                    [address]="session?.shippingAddress || null"
                                    [userId]="(phaseTwoUserId$ | async) ?? null"
                                    [userDetails]="{
                                      name: session?.customer?.name ?? '',
                                      email: session?.customer?.email ?? '',
                                      phone: session?.customer?.phone ?? '',
                                    }"
                                    [formControl]="phaseTwoMethod"
                                    [staffView]="true"
                                  ></vs-select-or-create-payment-method>

                                  <p *ngIf="phaseTwoMethodError" class="text-xs text-danger">
                                    {{ checkoutConfig.MULTI_PHASE_PHASE_TWO_METHOD_REQUIRED_ERROR }}
                                  </p>
                                </div>
                              </ng-container>
                            </div>

                            <!-- Ordinary payment remains available when Lemur is enabled and Pay now is selected. -->
                            <ng-container
                              *ngIf="
                                !payLater &&
                                !preview?.paymentCollectionUnavailable &&
                                !canFinanceWithBfs &&
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                !multiPhaseEnabled
                              "
                            >
                              <vs-accepted-payment-methods></vs-accepted-payment-methods>

                              <vs-select-or-create-payment-method
                                #input
                                [gatewayInstanceId]="purchase?.payments?.[0]?.gatewayInstanceId ?? null"
                                [address]="session?.shippingAddress || null"
                                [userId]="
                                  staffView
                                    ? (payingForCustomer$ | async)
                                      ? (currentUser$ | async)?.id || session!.customer!.userId
                                      : session!.customer!.userId
                                    : null
                                "
                                [userDetails]="{
                                  name: session?.customer?.name ?? '',
                                  email: session?.customer?.email ?? '',
                                  phone: session?.customer?.phone ?? '',
                                }"
                                [formControl]="paymentMethod"
                                [staffView]="staffView ?? false"
                              ></vs-select-or-create-payment-method>
                            </ng-container>

                            <ng-container
                              *ngIf="
                                (!canFinanceWithLemur || lemurPaymentMode === 'pay-now') &&
                                !(canFinanceWithBfs && bfsSelectedOption === 'budco')
                              "
                            >
                              <div class="flex items-center gap-2">
                                <input
                                  vsInput
                                  #evaluate
                                  type="checkbox"
                                  class="cursor-pointer"
                                  id="terms-and-conditions"
                                  name="termsAndConditions"
                                  [checked]="termsAndConditions"
                                  (change)="evaluateTermsAndConditions(evaluate.checked)"
                                />

                                <label
                                  vsCheckboxLabel
                                  for="terms-and-conditions"
                                  class="text-gray-700 text-xs cursor-pointer"
                                >
                                  By checking this box, you agree to {{ staffView ? 'the' : 'our' }}

                                  <a class="text-primary-500" (click)="previewPDFDialog.openDialog()">
                                    Terms and Conditions
                                  </a>
                                  <ng-container *ngIf="staffView">
                                    on behalf of {{ session?.customer?.name }}
                                  </ng-container>
                                  .
                                </label>
                              </div>
                            </ng-container>

                            <!-- Payment Buttons -->
                            <div
                              class="flex flex-col gap-2 mt-4"
                              *ngIf="
                                (canFinanceWithLemur && lemurPaymentMode === 'pay-now') ||
                                payLater ||
                                (!canFinanceWithBfs &&
                                  !canFinanceWithLemur &&
                                  (paymentInputsIdle || preview?.paymentCollectionUnavailable))
                              "
                            >
                              <ng-container *vsLet="isProcessingProvisioning$ | async as isProcessingProvisioning">
                                <button
                                  *ngIf="!canFinanceWithLemur || lemurPaymentMode === 'pay-now'"
                                  vs-button
                                  theme="primary"
                                  class="min-w-full"
                                  (click)="
                                    payLater
                                      ? onSkipPaymentAndConfirm(session?.id ?? '', staffView ?? false)
                                      : onProvision(session?.id ?? '', session?.hash ?? '', staffView ?? false)
                                  "
                                  [disabled]="
                                    isProcessingProvisioning ||
                                    (!(canFinanceWithBfs && bfsSelectedOption === 'budco') &&
                                      termsAndConditions === false) ||
                                    (!payLater && !isPaymentSelectionValid())
                                  "
                                >
                                  {{
                                    payLater
                                      ? canFinanceWithBfs
                                        ? checkoutConfig.PAY_LATER_TITLE
                                        : 'Continue to confirm'
                                      : 'Confirm payment'
                                  }}
                                </button>

                                <button
                                  vs-button
                                  appearance="outline"
                                  class="min-w-full"
                                  (click)="goBack(session, staffView ?? false)"
                                >
                                  Back
                                </button>
                              </ng-container>
                            </div>
                          </vs-card-content>
                        </vs-card>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-template #provisionWarranty>
                  <div
                    *vsLet="
                      staffView && needsPayLaterAcknowledgement(preview, selectedTerm$ | async) as payLaterRequired
                    "
                    class="flex flex-col"
                  >
                    <div class="flex flex-col gap-4 pb-6 justify-center items-center text-center">
                      <vs-featured-icon name="check-circle" theme="primary" size="28"></vs-featured-icon>
                      <div class="text-3xl font-semibold">{{ checkoutConfig.REVIEW_TITLE }}</div>
                      <div class="text-gray-600">
                        {{ checkoutConfig.REVIEW_SUBTITLE }}
                      </div>
                    </div>

                    <div class="max-w-[460px] flex flex-col gap-6">
                      <vs-card>
                        <vs-card-content class="flex flex-col p-6 gap-4">
                          <div class="text-sm">
                            With these steps concluded, you now possess all the essential details required for the
                            provisioning of this warranty for the customer.
                          </div>

                          <vs-divider></vs-divider>

                          <div
                            *ngIf="!(bfsSelectedOption === 'budco' && (canFinanceWithBfs$ | async))"
                            class="flex items-center gap-2"
                          >
                            <input
                              vsInput
                              #evaluate
                              type="checkbox"
                              class="cursor-pointer"
                              id="terms-and-conditions"
                              name="termsAndConditions"
                              [checked]="termsAndConditions"
                              (change)="evaluateTermsAndConditions(evaluate.checked)"
                            />

                            <label
                              vsCheckboxLabel
                              for="terms-and-conditions"
                              class="text-gray-700 text-xs cursor-pointer"
                            >
                              By checking this box, you agree to {{ staffView ? 'the' : 'our' }}

                              <a class="text-primary-500" (click)="previewPDFDialog.openDialog()">
                                Terms and Conditions
                              </a>
                              <ng-container *ngIf="staffView">
                                on behalf of {{ session?.customer?.name }}
                              </ng-container>
                              .
                            </label>
                          </div>

                          <!-- VS-1451: a priced sale with no payment schedule is only allowed as an explicit Pay Later -->
                          <div *ngIf="payLaterRequired" class="flex items-start gap-2 rounded bg-gray-50 border p-3">
                            <input
                              vsInput
                              #payLaterAck
                              type="checkbox"
                              class="cursor-pointer mt-0.5"
                              id="pay-later-acknowledgement"
                              [checked]="payLaterAcknowledged"
                              (change)="payLaterAcknowledged = payLaterAck.checked"
                            />
                            <label
                              vsCheckboxLabel
                              for="pay-later-acknowledgement"
                              class="text-gray-700 text-xs cursor-pointer"
                            >
                              <span class="font-semibold">Sell on Pay Later.</span>
                              No payment is taken now. The customer owes
                              {{ getRetailPrice(preview) | currency }}, and the warranty stays pending until that
                              balance is paid.
                            </label>
                          </div>
                        </vs-card-content>
                      </vs-card>

                      <div *ngIf="(purchase?.payments?.[0]?.amount ?? 0) <= 0" class="flex gap-2">
                        <!-- TODO: contact support? -->
                        <a *ngIf="!staffView" vs-button theme="primary" class="w-full" href="mailto:{{ contactEmail }}">
                          Contact us to provision this warranty
                        </a>
                        <button
                          vs-button
                          appearance="outline"
                          class="w-full"
                          (click)="goBack(session, staffView ?? false)"
                        >
                          Back
                        </button>

                        <ng-container *vsLet="isProcessingProvisioning$ | async as isProcessingProvisioning">
                          <button
                            *ngIf="staffView"
                            vs-button
                            theme="primary"
                            class="w-full"
                            (click)="
                              payLaterRequired
                                ? onSkipPaymentAndConfirm(session?.id ?? '', staffView)
                                : onProvision(session?.id ?? '', session?.hash ?? '', staffView)
                            "
                            [disabled]="
                              isProcessingProvisioning ||
                              (payLaterRequired && !payLaterAcknowledged) ||
                              (!(bfsSelectedOption === 'budco' && (canFinanceWithBfs$ | async)) &&
                                termsAndConditions === false)
                            "
                          >
                            Confirm
                          </button>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #loading>
      <div class="flex flex-col items-center justify-center w-full min-h-[350px]">
        <ng-container *ngIf="(paymentOptionsLoadState$ | async) === 'error'; else loadingPaymentOptions">
          <div *vsLet="session$ | async as session" class="flex flex-col items-center gap-4 text-center" role="alert">
            <vs-featured-icon name="alert-triangle" theme="warn"></vs-featured-icon>
            <p class="text-lg font-semibold">Unable to load payment options</p>
            <p class="text-sm text-gray-600">Please try again to continue checkout.</p>
            <div class="flex gap-2">
              <button vs-button appearance="outline" (click)="goBack(session, staffView ?? false)">Back</button>
              <button vs-button theme="primary" (click)="retryPaymentOptions()">Retry</button>
            </div>
          </div>
        </ng-container>
        <ng-template #loadingPaymentOptions>
          <vs-icon name="loading-01" class="text-primary-500 animate-spin" size="50"></vs-icon>
        </ng-template>
      </div>
    </ng-template>

    <ws-preview-pdf-dialog
      #previewPDFDialog
      class="h-full"
      [document]="termsDoc"
      (closed)="previewPDFDialog.closeDialog()"
    ></ws-preview-pdf-dialog>

    <vs-dialog #markupWarningDialog [config]="{ dialogContainerClass: 'max-w-[425px]' }">
      <vs-dialog-header
        [config]="{
          mode: 'simple',
          icon: 'alert-triangle',
          iconTheme: 'warn',
          title: 'No markup entered',
          subtitle:
            'You have not entered a markup on this sale. You may CONTINUE to payment without a markup; or STOP to add a markup before proceeding to payment.',
        }"
      ></vs-dialog-header>

      <div class="flex gap-2">
        <button vs-button appearance="outline" class="flex-1" (click)="cancelProceedWithoutMarkup()">Stop</button>
        <button vs-button theme="primary" class="flex-1" (click)="confirmProceedWithoutMarkup()">Continue</button>
      </div>
    </vs-dialog>
  </ng-template>
</ng-container>
